var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.13478 9.91674C3.71166 10.7801 4.5316 11.453 5.49091 11.8504C6.45022 12.2477 7.50582 12.3517 8.52422 12.1491C9.54262 11.9466 10.4781 11.4465 11.2123 10.7123C11.9465 9.97809 12.4466 9.04262 12.6491 8.02422C12.8517 7.00582 12.7477 5.95022 12.3504 4.99091C11.953 4.0316 11.2801 3.21166 10.4167 2.63478C9.55339 2.05791 8.53835 1.75 7.5 1.75C6.03231 1.75552 4.62357 2.32821 3.56833 3.34833L2.25 4.66667",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 1.75V4.66667H5.16667",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default __webpack_public_path__ + "assets/eaea3d1fe712322ea5c5d90047f4ff0f.svg";
export { SvgRefresh as ReactComponent };


// WEBPACK FOOTER //
// ./assets/icons/refresh.svg